const convertDecimalPlaces = value => {
  const isDot = String(value).indexOf('.') !== -1
  const decimalPlaces = String(value)
    .split(isDot ? '.' : ',')
    .join('').length
  return decimalPlaces > 3 ? Number(Number(value).toFixed(3)) : value
}

export default convertDecimalPlaces
